
// --- Slider ---

// Create a paginator
document.querySelectorAll('.slider').forEach(function(node) {
  if (! node.querySelector('.slider-paginator')) {
    let element = document.createElement('div')
    element.classList.add('slider-paginator', 'hidden')
    node.appendChild(element)
  }

  let childrenL = node.querySelectorAll('.slider-list .slide').length,
      myPaginator = node.querySelector('.slider-paginator')

  for (let i = 1; i <= childrenL; ++i){
    let element = document.createElement('button')
    element.setAttribute('data-slider', i)
    myPaginator.appendChild(element)
  }

  node.querySelector('.slider-paginator button:first-child').classList.add('active')
})

// Click a paginator point - content (shifting)
document.querySelectorAll('.tabs .slider-paginator button, .content .slider-paginator button').forEach(function(node) {
  node.addEventListener('click', function(e) {
    let mySlider = this.closest('.slider'),
        currentSlide = this.getAttribute('data-slider'),
        newLeft

    // Reset slider-pause
    if (automatic) {
      mySlider.querySelector('.slider-pause').classList.remove('slider-pause--pause','slider-pause--play')
    }

    let marginReducer = Number.parseFloat(mySlider.querySelector('.slide:nth-child(' + currentSlide + ')').style.marginLeft) ? Number.parseFloat(mySlider.querySelector('.slide:nth-child(' + currentSlide + ')').style.marginLeft) : 0

    // Calculate left margin
    newLeft = - mySlider.querySelector('.slide:nth-child(' + currentSlide + ')').offsetLeft
              - marginReducer

    // Animate list
    let sliderList = mySlider.querySelector('.slider-list')
    sliderList.style.left = newLeft + 'px'

    // Deactivate previous slide
    mySlider.querySelectorAll('.slider-paginator button').forEach(function(node) {
      node.classList.remove('active')
    })
    mySlider.querySelectorAll('.slide').forEach(function(node) {
      node.classList.remove('active')
    })

    // Activate this slide and paginator point
    mySlider.querySelector('.slider-paginator button[data-slider="'+currentSlide+'"]').classList.add('active')
    mySlider.querySelector('.slide:nth-child(' + currentSlide + ')').classList.add('active')

    // Add class to slide-pause
    if (automatic) {
      mySlider.querySelector('.slider-pause').classList.add('slider-pause--pause')
    }
  })
})

// Click a prev/next button
document.querySelectorAll('.slider-prev').forEach(function(node) {
  node.addEventListener('click', function(e) {
    let mySlider = this.closest('.slider'),
        currentActive = mySlider.querySelectorAll('.slider-paginator button.active')[0]

    if (currentActive.previousElementSibling){
      // Numbered slider
      if (currentActive.previousElementSibling.classList.contains('nopoint')) {
        currentActive.previousElementSibling.previousElementSibling.click()
      // Regular slider
      } else {
        currentActive.previousElementSibling.click()
      }
    } else {
      mySlider.querySelector('.slider-paginator button:last-child').click()
    }
    sliderAuto()
  })
})

document.querySelectorAll('.slider-next').forEach(function(node) {
  node.addEventListener('click', function(e) {
    let mySlider = this.closest('.slider'),
        activePaginatorPoints = mySlider.querySelectorAll('.slider-paginator button.active'),
        currentActive = activePaginatorPoints[activePaginatorPoints.length - 1]

    if (currentActive.nextElementSibling){
      // Numbered slider
      if (currentActive.nextElementSibling.classList.contains('nopoint')) {
        currentActive.nextElementSibling.nextElementSibling.click()
      // Regular slider
      } else {
        currentActive.nextElementSibling.click()
      }
    } else {
      mySlider.querySelector('.slider-paginator button:first-child').click()
    }
    sliderAuto()
  })
})

// Automatic slide changer
let automatic = true,
    timer

function sliderAuto () {
  clearTimeout(timer)
  timer = setTimeout(function(){
    if (automatic) {
      document.querySelectorAll('.slider .slider-next').forEach(function(node) {
        node.click()
      })
    }
  }, 5000)
}
sliderAuto()

// Pause/play
document.querySelectorAll('.slider-pause-icon').forEach(function(node) {
  node.addEventListener('click', function(e) {
    clearTimeout(timer)
    automatic = ! automatic
    node.closest('.slider-pause').classList.toggle('slider-pause--pause', 'slider-pause--play')

    if (automatic) {
      sliderAuto()
    }
  })
})

// Init
function sliderActivator () {
  document.querySelectorAll('.slider').forEach(function(node) {
    node.querySelector('.slider-paginator button.active').click()
  })
}
sliderActivator()

window.addEventListener('resize', function(e){
  document.querySelectorAll('.slider').forEach(function(node) {
    node.querySelector('.slider-paginator button:first-child').click()
  })
})
